import {useQuery, UseQueryOptions} from '@tanstack/react-query'
import {Role} from '../types'
import {QUERY_KEYS} from '@/queryClient'
import {parseAxiosPromise} from '@/axiosInstance'
import {httpGetRole} from '@/features/users/http/users.http'
import {captureException} from '@sentry/react'

export const useGetRole = (roleId: Role['id'], options?: Omit<UseQueryOptions<Role>, 'queryFn' | 'queryKey'>) =>
    useQuery({
        queryKey: [QUERY_KEYS.ROLE_PERMISSIONS, roleId],
        queryFn: () =>
            parseAxiosPromise({
                axiosPromise: httpGetRole({
                    urlParams: {roleId},
                    params: {responseType: 'extended'}
                }),
                responseShape: Role,
                onZodError: captureException
            }),
        ...options
    })
